class BarracudaVunit{
    constructor() {
        // init value
        this.defineViewSizeLast = { "width": 0, "height": 0 }
        // create array of css variables
        this.vars = [{"name": "vh100", "percent": 1, "from": "height"},{"name": "vw100", "percent": 1, "from": "width"}]
        // Add listener for resizing
        window.addEventListener("resize", this.defineViewSize.bind(this), false);
        //run initialization
        this.defineViewSize();
    }     
    defineViewSize(changes = 0) {
        // Get current sizes
        let defineViewSizeCurrent = { "width": document.documentElement.clientWidth, "height": document.documentElement.clientHeight }
        // Check for changes
        if (defineViewSizeCurrent.height != this.defineViewSizeLast.height && defineViewSizeCurrent.width != this.defineViewSizeLast.width)
            changes = 1
        else if (defineViewSizeCurrent.height != this.defineViewSizeLast.height) {
            changes = 2
        } else if (defineViewSizeCurrent.width != this.defineViewSizeLast.width) {
            changes = 3
        }
        if(changes > 0){
            // Save new sizes
            this.defineViewSizeLast = defineViewSizeCurrent;
            // Refresh all variables
            this.vars.forEach(element => {
                // check if we need refresh variable
                if(changes = 1 || (element.from == "height" && changes == 2) || (element.from == "width" && changes == 3))
                    document.querySelector(':root').style.setProperty('--'+element.name, (element.percent * defineViewSizeCurrent[element.from]) + 'px');
            })
        }
    }
    addVar(name, percent, from) {
        // add to library
        this.vars.push({ "name": name, "percent": parseInt(percent) / 100, "from": from })
        // force refresh
        this.defineViewSize(1)
    }
}
// add library to enviroment
BarracudaStore.libraries['barracuda-vunit'] = new BarracudaVunit()
// notify everyone that we add controller
window.dispatchEvent(new CustomEvent('libraryLoaded'));